<template>
<div>
	<b-navbar class="submenu">
		<b-container>
			<b-navbar-brand href="#">PSM Administration</b-navbar-brand>
			<b-collapse id="nav-collapse-sub" is-nav>
				<b-navbar-nav>
					<a href="#" @click="newPsm()">New PSM</a>
					<a href="#" @click="savePsm()" v-if="psm">Save</a>
					<a href="#" @click="deleteSelected()" v-if="psm">Delete</a>
					<a href="#" @click="onLoad()" v-if="psm">Reload</a>
				</b-navbar-nav>
			</b-collapse>
		</b-container>
	</b-navbar>
	<div id="content">

		<b-modal id="modMessage" hide-backdrop content-class="shadow" header-bg-variant="dark" header-text-variant="light" title="Admin">
			<p class="my-4">{{message}}</p>
		</b-modal>

		<b-modal id="modSure" hide-backdrop content-class="shadow" header-bg-variant="dark" header-text-variant="light" title="Really?">
			<p class="my-4">Are you sure?</p>
			<template #modal-footer="{ ok, cancel }">
				<b-button variant="success" @click="doDeleteSelected()">Yes</b-button>
				<b-button variant="danger" @click="cancel()">No</b-button>
			</template>
		</b-modal>

		<div class="row">
			<div class="col-md-3 mb-4">
				<div class="filters">
					<b-button-group>
						<b-button @click="getPsms" size="sm" variant="outline-success">All</b-button>
						<b-button @click="psms = cms" size="sm" variant="outline-success">CMS</b-button>
						<b-button @click="psms = screen" size="sm" variant="outline-success">Screen</b-button>
						<b-button @click="psms = website" size="sm" variant="outline-success">Website</b-button>
					</b-button-group>
				</div>
				<b-form-input placeholder="search" class="mb-2" v-model="search"></b-form-input>
				<small>{{psms.length}} PSMs</small>
				<div class="leftSide">
					<b-table striped hover :filter="search" :items="psms" :fields="[{key: 'name', label: 'PSM'}, 'enabled', {key:'priority', label: 'P'}]" selectable select-mode="single" @row-clicked="selectPsm"></b-table>
				</div>
			</div>
			<div class="col-md-9" v-if="psm">
				<div class="m-5 mt-0">
					<h2>{{psm.name}}</h2>
					<div class="mb-2"><small>ID: {{psm.id}}</small></div>
					<div class="row">
						<div class="col-md-4">
							Name: <b-form-input class="mb-2" v-model="psm.name"></b-form-input>
						</div>
						<div class="col-md-4">
							Title: <b-form-input class="mb-2" v-model="psm.title"></b-form-input>
						</div>
						<div class="col-md-1">
							Priority: <b-form-input class="mb-2" v-model="psm.priority"></b-form-input>
						</div>
						<div class="col-md-1">
							Enabled: <b-form-checkbox class="mb-2" v-model="psm.enabled"></b-form-checkbox>
						</div>
						<div class="col-md-1">
							Sticky: <b-form-checkbox class="mb-2" v-model="psm.sticky"></b-form-checkbox>
						</div>
						<div class="col-md-1">
							Signup: <b-form-checkbox class="mb-2" v-model="psm.onSignup"></b-form-checkbox>
						</div>
					</div>
					
					<div class="row">
						<div class="col-md-11">
							Criteria: <b-form-textarea class="mb-2 criteria-text" v-model="psm.criteria"></b-form-textarea>
						</div>
						<div class="col-md-1">
							<br/>
							<b-button v-b-toggle.sidebar size="sm">...</b-button>
						</div>
					</div>
					<div class="row">
						<div class="col-md-6">
							Tag Line: <b-form-input class="mb-2" v-model="psm.tagLine"></b-form-input>
						</div>
						<div class="col-md-6">
							Feature tags (admin only): <b-form-input class="mb-2" v-model="psm.featureTags"></b-form-input>
						</div>
					</div>
					Description: <b-form-textarea class="mb-2" v-model="psm.description"></b-form-textarea>
					<div class="row">
						<div class="col-md-4">
							Time to Complete (mins): <b-form-input class="mb-2" v-model="psm.timeToComplete"></b-form-input>
						</div>
						<div class="col-md-4">
							Delay after customer delay (days): <b-form-input class="mb-2" v-model="psm.defaultDelayPeriodDays"></b-form-input>
						</div>
						<div class="col-md-4">
							Delay after actioned (days): <b-form-input class="mb-2" v-model="psm.delayAfterActionDays"></b-form-input>
						</div>
					</div>
					<div class="row">
						<div class="col-md-4">
							Show only once per spending cycle: <b-form-checkbox class="mb-2" v-model="psm.oncePerSpendingCycle"></b-form-checkbox>
						</div>
					</div>
					Action Button Text: <b-form-input class="mb-2" v-model="psm.actionButtonText"></b-form-input>
					Background Image: <b-form-input class="mb-2" v-model="psm.backgroundImage"></b-form-input>
					<div><b-img class="mb-2" width="200" thumbnail :src="psm.backgroundImage"></b-img></div>
					Background Video: <b-form-input class="mb-2" v-model="psm.backgroundVideo"></b-form-input>
					Thumbnail: <b-form-input class="mb-2" v-model="psm.thumbnail"></b-form-input>
					<div><b-img class="mb-2" width="200" thumbnail :src="psm.thumbnail"></b-img></div>
					<div class="actions-card">
						<div>
							<h6>Move action:</h6>
							1) <b-button class = "btn-md m-2" v-bind:style="{'background-color': actionType == 'appScreen' ? 'green' : 'grey'} " @click="updatePsmAction('appScreen')">App Screen</b-button>
							<b-button class = "btn-md m-2" v-bind:style="{'background-color': actionType == 'cmsPage' ? 'green' : 'grey'} " @click="updatePsmAction('cmsPage')">CMS Page</b-button>
							<b-button class = "btn-md m-2" v-bind:style="{'background-color': actionType == 'websiteUrl' ? 'green' : 'grey'} " @click="updatePsmAction('websiteUrl')">Website URL</b-button>
							<b-button class = "btn-md m-2" v-bind:style="{'background-color': actionType == 'bakedAction' ? 'green' : 'grey'} " @click="updatePsmAction('bakedAction')">Baked Action</b-button>
						</div>
						<div v-if="actionType=='appScreen'">
							<p>2) Choose a well known app screen from the dropdown, or enter it manually in the text box.</p>
							<b-row>
								<b-col>
									Select: <b-form-select class = "mb-2" v-model="psm.appScreen" :options="appScreenOptions" ></b-form-select>
								</b-col>
								<b-col>
									Manual: <b-form-input class="mb-2" v-model="psm.appScreen"></b-form-input> 
								</b-col>
							</b-row>
							<div v-if="this.psm.appScreen != null && this.psm.appScreen.includes('Questionnaires') && !this.psm.appScreen.includes('InBest')">
								3) Questionnaire Key: <b-form-input class="mb-2"  @update="setQuestionnaire"></b-form-input> 
								4) Number of questions per page: <b-form-input class="mb-2" @update="setQuestionsPerPage" ></b-form-input> 
							</div>
							<div class="mt-5 mb-3" v-bind:style="{'font-weight': 'bold'}">
								Final Move Action (admin):<p> {{psm.appScreen}}</p> 
							</div>
						</div>
						<div v-if="actionType=='cmsPage'">
							2) CMS Page Key: <b-form-input class="mb-2" v-model="psm.cmsPage"></b-form-input>
							<div class="mt-5 mb-3" v-bind:style="{'font-weight': 'bold'}">
								Final Move Action (admin):<p> {{psm.cmsPage}}</p> 
							</div>
						</div>
						<div v-if="actionType=='websiteUrl'"> 
							2) Website URL: <b-form-input class="mb-2" v-model="psm.websiteUrl"></b-form-input>
							<div class="mt-5 mb-3" v-bind:style="{'font-weight': 'bold'}">
								Final Move Action (admin):<p> {{psm.websiteUrl}}</p> 
							</div>
						</div>
						<div v-if="actionType=='bakedAction'"> 
							2) Action: <b-form-input class="mb-2" v-model="psm.bakedAction"></b-form-input>
							<div class="mt-5 mb-3" v-bind:style="{'font-weight': 'bold'}">
								Final Move Action (admin):<p> {{psm.bakedAction}}</p> 
							</div>
						</div>
					</div>
					<div v-if="actionType != 'bakedAction'">
						<div v-for="action in psm.actions" :key="action.id" >
							<AppActionCard
								:action="action"
								@onDeleteAction="removeAction(psm, action)" 
							/> 
						</div>
					</div>
					<div class="row" v-if="actionType != 'bakedAction'">
						<div class="col-md-4">
							<b-button @click="addAction(psm)" variant="success">Add Action</b-button>
						</div>
					</div>	
					<br/>	
					Dark Mode: <b-form-checkbox class="mb-2" v-model="psm.darkMode"></b-form-checkbox>
					Sends push notification: <b-form-checkbox class="mb-2" v-model="psm.isAlsoNotification"></b-form-checkbox>
					Is ONLY notification (not in app moves): <b-form-checkbox class="mb-2" v-model="psm.isOnlyNotification"></b-form-checkbox>
					<div v-if="psm.isAlsoNotification || psm.isOnlyNotification">
						Notification Title: <b-form-input class="mb-2" v-model="psm.notificationTitle"></b-form-input>
						Notification Body: <b-form-input class="mb-2" v-model="psm.notificationBody"></b-form-input>
						Notification Image (optional): <b-form-input class="mb-2" v-model="psm.notificationImageUrl"></b-form-input>
					</div>
					<b-sidebar id="sidebar" class="sidebar" title="" right shadow>
						<div class="px-4 py-2">
							<div id="criteria">
								<b-button :title="c.description" class="btn-sm" v-for="c in criteria" :key="c.id" @click="psm.criteria += c.fact">{{c.fact}}</b-button>
							</div>
						</div>
					</b-sidebar>
				</div>
			</div>
		</div>
	</div>
</div>
</template>
<script>
import AppActionCard from "./Widgets/AppActionCard";
export default {
  name: 'PSMs',
  components: {
	AppActionCard
  },
  data() {
	return{
		cms: null,
		screen: null,
		website: null,
		psms: null,
		psm: null,
		actionType: null,
		appScreenOptions: [ ],
		message: null,
		error: null,
		criteria: null,
		search: ""
	}
  },
  methods: {
	setActionType: function() {
		this.actionType = null;
		if (this.psm == null) { return null;  }
		if (this.psm.appScreen != null && this.psm.appScreen != "") {  this.actionType = "appScreen"; }
		if (this.psm.cmsPage != null && this.psm.cmsPage != "") { this.actionType =  "cmsPage"; }
		if (this.psm.websiteUrl != null && this.psm.websiteUrl != "") { this.actionType = "websiteUrl"; }
		return this.actionType;
	}, 
	setQuestionnaire: function(key) {
		const arr = this.psm.appScreen.split("/");
		// console.log(arr);
		const q = arr[4] != null && arr[4] != "" && arr[4] != "undefined" && key != "InBest" ? "/" + arr[4] : "";
		this.psm.appScreen =   "appscreen/Questionnaires/" + key + q;
	},
	setQuestionsPerPage: function(qpp) {
		const arr = this.psm.appScreen.split("/");
		this.psm.appScreen =   "appscreen/Questionnaires/" + arr[3] + "/" + qpp;
	},
	updatePsmAction: function(action) {
		this.actionType = action;
		if (action == "appScreen") {
			this.psm.cmsPage = "";
			this.psm.websiteUrl = "";
			this.psm.bakedAction = "";
		}
		if (action == "cmsPage") {
			this.psm.appScreen = "";
			this.psm.websiteUrl = "";
			this.psm.bakedAction = "";
		}
		if (action == "websiteUrl") {
			this.psm.cmsPage = "";
			this.psm.appScreen = "";
			this.psm.bakedAction = "";
		}
		if (action == "bakedAction") {
			this.psm.cmsPage = "";
			this.psm.appScreen = "";
			this.psm.websiteUrl = "";
		}
	},
	addAction: function(step) {
		step.actions.push({
			cta: "",
			appScreen: "",
			cmsPage: "",
			externalURL: ""
		});
	},
	removeAction: function(step, action) {
		var i = step.actions.indexOf(action);
		step.actions.splice(i, 1);
	},
	getPsms: function(autoSelect){
		this.$http.get(this.$config.ApiUri + "/Moves")
			.then((result) => {
				this.psms = result.data;
				this.cms = new Array();
				this.screen = new Array();
				this.website = new Array();
				for(var x = 0; x < this.psms.length; x++)
				{
					if (this.psms[x].cmsPage != null)
					{
						this.cms.push(this.psms[x]);
					}
					if (this.psms[x].appScreen != null)
					{
						this.screen.push(this.psms[x]);
					}
					if (this.psms[x].websiteUrl != null)
					{
						this.website.push(this.psms[x]);
					}
				}
				if (autoSelect) {
					if (this.psms.length > 0) {
						this.selectPsm(this.psms[0]);
					}
				}
			}
		)
	},
	getCriteria: function(){
		this.$http.get(this.$config.ApiUri + "/Criteria")
			.then((result) => {
				this.criteria = result.data;
				this.criteria.sort();
			}
		)
	},
	selectPsm: function(p) {
		this.psm = p;
		this.setActionType();
	},
	savePsm: function(){
		if (this.psm.id == null) {
			this.$http.post(this.$config.ApiUri + "/Moves", this.psm)
				.then((result) => {
					this.psm = result.data;
					this.getPsms(false);
					this.showMessage("PSM created OK!");
				}
			).catch(() => { this.showError(); });
		}
		else {
			this.$http.put(this.$config.ApiUri + "/Moves/" + this.psm.id, this.psm)
				.then((result) => {
					this.psm = result.data;
					this.getPsms(false);
					this.showMessage("PSM saved OK!");
				}
			).catch(() => { this.showError(); });
		}
	},
	deleteSelected() {
		this.$bvModal.show('modSure');
	},
	doDeleteSelected() {
		this.$bvModal.hide('modSure');
		this.$http.delete(this.$config.ApiUri + "/Moves/" + this.psm.id)
			.then(() => {
				this.psm = null;
				this.getPsms(true);
				this.showMessage("PSM deleted OK!");
			}
		).catch((error) => { this.showError("Sorry, that PSM cannot be deleted.  This may mean moves have already been generated against it.  We cannot rewrite history. (" + error + ")"); });
	},
	newPsm() {
		this.psm = { 
			"criteria": "",
			"sticky" : false,
			"financialRank": 0,
			"wellbeingRank": 0,
			"validFrom": "2022-03-15",
			"validTo": "2029-03-15",
			"defaultDelayPeriodDays": 7,
			"name": "",
			"priority": this.psms.length + 1,
			"oncePerSpendingCycle": false,
			"title": "",
			"tagLine": "",
			"description": "",
			"actionButtonText": "",
			"backgroundImage": "",
			"backgroundVideo": "",
			"thumbnail": "",
			"darkMode": false,
			"websiteUrl": "",
			"appScreen": "",
			"cmsPage": "",
			"actions": [],
			"timeToComplete": 0,
			"enabled": false,
			"onSignup": false,
			"isAlsoNotification": false,
			"isOnlyNotification": false
		};
		this.actionType = null;
	},
	showMessage(message) {
		this.message=message;
		this.$bvModal.show('modMessage');
		setTimeout(() => this.$bvModal.hide('modMessage'), 3000);
	},
	showError(message) {
		if (!message) { message = "Sorry, that didn't work, please contact Tris"; }
		this.message=message;
		this.$bvModal.show('modMessage');
		setTimeout(() => this.$bvModal.hide('modMessage'), 3000);
	},
	onLoad() {
		this.getPsms(true);
		this.getCriteria();
	}
  },
  mounted: function() { this.onLoad(); }
}
</script>

<style>
.filters
{
	margin-bottom: 10px;
	width: 100%;
}

.filters .btn-group
{
	width: 100%;
}

.modal-header .close {
  display:none;
}
#criteria .btn-sm {
	margin:3px;
	font-size:10px;
}
.actions-card {
	padding: 20px;
	margin-bottom: 10px;
	background-color:aliceblue;
}
.criteria-text
{
	font-family: monospace !important;
	color:white !important;;
	background-color: rgb(56, 56, 56) !important;;
}
</style>